import { render, staticRenderFns } from "./cashBoxesOpeningBalance.vue?vue&type=template&id=7056ac5a&scoped=true"
import script from "./cashBoxesOpeningBalance.vue?vue&type=script&lang=js"
export * from "./cashBoxesOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./cashBoxesOpeningBalance.vue?vue&type=style&index=0&id=7056ac5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7056ac5a",
  null
  
)

export default component.exports